import React, {
  useEffect,
  useRef,
  useState
} from "react";

import {
  graphql,
  Link,
  useStaticQuery
} from "gatsby";

import "./MobileMenu.scss";

import {
  getInitialLocale,
  type SupportedLocale,
} from "../../utils/i18n";



interface NavigationItem {

  title: string;

  slug: string;

  type: string;

}



interface NavigationGroup {

  title: string;

  order: number;

  items: NavigationItem[];

}



export default function MobileMenu() {


  const menuRef =
    useRef<HTMLDivElement>(null);



  const [locale, setLocale] =
    useState<SupportedLocale>("en");



  const [open, setOpen] =
    useState(false);



  const [openCategory, setOpenCategory] =
    useState<string | null>(null);




  useEffect(() => {

    setLocale(getInitialLocale());

  }, []);




  /*
    Chiude il menu
    cliccando fuori
  */

  useEffect(() => {


    const handleClickOutside =
      (event: MouseEvent) => {


        if (

          menuRef.current &&

          !menuRef.current.contains(
            event.target as Node
          )

        ) {

          setOpen(false);

          setOpenCategory(null);

        }


      };



    document.addEventListener(
      "mousedown",
      handleClickOutside
    );



    return () => {

      document.removeEventListener(
        "mousedown",
        handleClickOutside
      );

    };


  }, []);





  const data = useStaticQuery(graphql`

    query MobileNavigationQuery {

      allMarkdownRemark {

        nodes {

          frontmatter {

            locale

            title

            slug

            type

            menuTitle

            menuOrder

            showInMenu

          }

        }

      }

    }

  `);




const contents =
  locale
    ? data.allMarkdownRemark.nodes
        .filter((node:any)=>{
          return (
            node.frontmatter.locale === locale &&
            node.frontmatter.showInMenu === true
          );
        })
    : [];





  const groups: NavigationGroup[] = [];




 contents.forEach((node:any)=>{

  const item = node.frontmatter;


  const existingGroup =
    groups.find(
      group =>
        group.title === item.menuTitle
    );


  if(existingGroup){

    existingGroup.items.push({

      title:item.title,

      slug:item.slug,

      type:item.type

    });


  } else {


    groups.push({

      title:item.menuTitle,

      order:item.menuOrder ?? 99,

      items:[

        {

          title:item.title,

          slug:item.slug,

          type:item.type

        }

      ]

    });


  }

});





  groups.sort(

    (a,b)=>

      a.order - b.order

  );





  const toggleMenu = () => {


    setOpen(!open);


    if(open){

      setOpenCategory(null);

    }

  };




  return (

    <div

      className="mobileMenu"

      ref={menuRef}

    >



      <button

        className="hamburger"

        onClick={toggleMenu}

        aria-label="Menu"

        aria-expanded={open}

      >


        ☰


      </button>





      {open && (



        <div className="mobileDropdown">


          {groups.map((group, groupIndex) => (



            <div

              key={`${group.title}-${groupIndex}`}

              className="mobileCategory"

            >



              <button

                className="categoryButton"

                onClick={() =>


                  setOpenCategory(

                    openCategory === group.title

                      ? null

                      : group.title

                  )


                }

              >


                <span>
                  {group.title}
                </span>


                <span>

                  {

                    openCategory === group.title

                    ? "▲"

                    : "▼"

                  }


                </span>


              </button>





              {openCategory === group.title && (



                <div className="mobileItems">


                  {group.items.map((item, itemIndex) => (



                    <Link

                      key={`${item.slug}-${itemIndex}`}

                      to={`/${locale ?? "en"}/${item.slug}`}

                      className="mobileItem"

                      onClick={() => {


                        setOpen(false);

                        setOpenCategory(null);


                      }}

                    >

                     {item.title}


                    </Link>



                  ))}


                </div>



              )}



            </div>



          ))}



        </div>



      )}



    </div>

  );

}